<template>
  <v-container fluid>
    <material-card icon="mdi-google-classroom" title="View onboarded student class details">
      <v-card-actions>
          <router-link slot="right" :to="{ name: 'viewMotherToddlerProgram' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card-component>
          <v-row>
            <v-col cols="12" lg="12" sm="12">
               <v-card v-for="title in titles" :key="title">
            <v-card-title>
              {{title}}
              <v-spacer></v-spacer>
            </v-card-title>

              <v-data-table
            :headers="headers"
            :items="getTableItems(title)"
            :hide-default-footer="true"
          >
            <template v-slot:item.className="{ item }">
              {{ item.studentAdmission.class || '-' }}
            </template>
              <template v-slot:item.section="{ item }">
              {{ item.studentAdmission.section || '-' }}
            </template>
             <template v-slot:item.classStartDate="{ item }">
              {{ formatDate(item.classStartDate) || '-' }}
            </template>
             <template v-slot:item.classEndDate="{ item }">
              {{ formatDate(item.classEndDate) || '-' }}
            </template>

            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
          </v-card>
              </v-col>
              </v-row>
        </v-card-component>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'viewStudentClassDetails',
  props: ['studentID'],
  components: { MaterialCard, VCardComponent },
  data () {
    return {
      activeTab: null,
      titles: ['Current classes', 'Upcoming classes', 'Completed classes'],
      headers: [
        { text: 'Class Name', value: 'className' },
        { text: 'Section', value: 'section' },
        { text: 'Class Start Date', value: 'classStartDate' },
        { text: 'Class End Date', value: 'classEndDate' }
      ],
      onboardedStudentList: null,
      currentClassList: [],
      upcomingClassList: [],
      completedClassList: [],
      title: null

    }
  },

  async created () {
    await this.getAllOnboardedStudentList()
  },

  methods: {
    getAllOnboardedStudentList: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/mother-toddler/classes/${this.studentID}`)
        this.onboardedStudentList = data
        this.currentClassList = data.currentClass
        this.upcomingClassList = data.upComingClasses
        this.completedClassList = data.completedClasses
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting onboarded student list data: ${errorMessage}`)
      }
    },
    getTableItems (title) {
      switch (title) {
        case 'Current classes':
          return this.currentClassList
        case 'Upcoming classes':
          return this.upcomingClassList
        case 'Completed classes':
          return this.completedClassList
        default:
          return []
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
